// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3RO_y","colMin":"styles_colMin__UjOMn","colCheckbox":"styles_colCheckbox__Rf0BD"};